/*eslint-disable */
import {
  mapGetters
} from 'vuex';
const $ = window.jQuery = require('jquery');
import axios from 'axios';
import toast from '../../../services/toast';
export default {
  name: 'webinar-list',
  components: {},
  props: [],
  data() {
    return {
      submitted:false,
      webinarListDetails: {},
      webinarStatusPopup: false,
      webinarActvStatus: Boolean,
      webinarStatusId: ''
    }
  },
  computed: {
    ...mapGetters([
      'getWebinarAllListOfAdminGetters'
    ]),
    getWebinarList() {
      this.webinarListDetails = this.$store.getters.getWebinarAllListOfAdminGetters.data;
      return
    },
  },
  mounted() {
    this.getWebinarList
  },
  methods: {
    getWebinarListAgain(){
      this.$store.dispatch('getWebinarAllListOfAdminFun').then((res)=>{
      })
    },
    updateWebinarDetails(itemId, ItemStatus) {
      this.webinarActvStatus = ItemStatus
      this.webinarStatusId = itemId
      this.webinarStatusPopup = true
      $('body').addClass('body_right_scroll_remove')
    },
    closeWebinarStatusPopup() {
      this.webinarActvStatus = ''
      this.webinarStatusId = ''
      this.webinarStatusPopup = false
      $('body').removeClass('body_right_scroll_remove')
    },
    updateStatusOfWebinarMethod() {
      this.submitted = true
      var data = {is_active : this.webinarActvStatus}
      this.$store.dispatch('updateWebinarDetailsByIdFun', { data: { data: data, id: this.webinarStatusId} }).then((res) => {
        toast.success(res.data.msg);
        this.getWebinarListAgain()
        this.submitted = false
        this.closeWebinarStatusPopup()
      }).catch((err) => {
        this.submitted = false
        toast.error(err.data.msg);
      })
    }
  },
  watch: {
    getWebinarList() {
      return this.$store.getters.getWebinarAllListOfAdminGetters
    },
  },
  beforeCreate: function () {
  },
  beforeRouteLeave: function (to, from, next) {
    next();
  },
}